export const TEXT = {
  SOLD_OUT: 'Sold Out',
};

export const WISHLIST_ICON_SIZE = 16;
